import { render, staticRenderFns } from "./EditTabStaffAccount.vue?vue&type=template&id=6bff4d4b"
import script from "./EditTabStaffAccount.vue?vue&type=script&lang=js"
export * from "./EditTabStaffAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports